import checkout from "./form";

const {
  formField: {
    companyName,
    companyTaxId,
    taxAuthorities,
    numberSupplier,
    numberSupplierAuthority,
    period,

    firstTime,
    replaceNumber,

    fullName,
    signer,
    timeSign,
    certificate,
  },
} = checkout;

const initialValues = {
  [fullName.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
  [certificate.name]: "",

  [companyName.name]: "",
  [companyTaxId.name]: "",
  [taxAuthorities.name]: "",
  [numberSupplier.name]: "",
  [numberSupplierAuthority.name]: "",
  [period.name]: "",
  [firstTime.name]: "",
  [replaceNumber.name]: "",
};

export default initialValues;
